import styled, { css } from 'styled-components/macro';

export const Wrapper = styled.button<{
  $isHighlighted: boolean;
}>`
  ${({ theme, $isHighlighted }) => css`
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 4px;
    width: 100%;
    background-color: ${$isHighlighted
      ? theme.semantic.bg.surface2Hover
      : theme.semantic.bg.surface};
    color: ${theme.semantic.text.default};
    transition-duration: 0.2s;
    cursor: pointer;
    outline: none;
    border: none;

    &:disabled {
      cursor: not-allowed;
      background-color: ${theme.semantic.bg.surfaceSubtle};
      color: ${theme.semantic.text.disabled};
    }

    &:not(:disabled):hover {
      background-color: ${theme.semantic.bg.surface2Hover};
    }

    &[data-selected='true'] {
      background-color: ${$isHighlighted
        ? theme.semantic.bg.selectedHover
        : theme.semantic.bg.selected};

      &:hover {
        background-color: ${theme.semantic.bg.selectedHover};
      }
    }
  `}
`;
